import React, { useCallback } from 'react';
import { Platform, StyleSheet, TouchableOpacity, View } from 'react-native';
import { hitSlop, rem, Spacer } from 'design-system';
import IconCheck from 'design-system/icons/IconCheck';
import Text from 'design-system/Text';
import useColors from 'hooks/useColors';
import Links from 'utils/links';
import { splitAmounts } from 'utils/text/splitAmounts';
import { useMainStackNavigation } from 'utils/types/navigationV6';
const ListInfoItem = ({ title, url }) => {
    const colors = useColors();
    const { navigateDeprecated } = useMainStackNavigation();
    const handleLearnMore = useCallback(() => {
        if (url) {
            if (Platform.OS === 'android') {
                navigateDeprecated('Pdf', { url, buttonTitle: 'Done' });
            }
            else {
                Links.openLink(url);
            }
        }
    }, [url]);
    return (<>
      <View style={styles.container}>
        <IconCheck thick color={colors.elements.brand}/>
        <Spacer w={12}/>
        <View style={styles.flex}>
          <Text TextThin-14 Secondary>
            {splitAmounts(title).map((segment, index) => segment.isAmount ? (<Text key={index} NumbersThin-14 Secondary>
                  {segment.text}
                </Text>) : (segment.text))}
          </Text>
        </View>
      </View>
      {!!url && (<View style={styles.learnMoreContainer}>
          <TouchableOpacity hitSlop={hitSlop} onPress={handleLearnMore}>
            <Text Primary Text-14>
              Learn more
            </Text>
          </TouchableOpacity>
        </View>)}
      <Spacer.H8 />
    </>);
};
export default ListInfoItem;
const styles = StyleSheet.create({
    container: {
        flex: 1,
        flexDirection: 'row',
    },
    learnMoreContainer: {
        marginLeft: rem(36),
    },
    flex: {
        flex: 1,
    },
});
